export default __webpack_public_path__ + "static/media/dl_landscape_flyer.7f161842.png";